import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "md:h-40 md:w-60 h-28 w-28 bg-white rounded-md flex flex-col items-center text-center md:px-3 px-1 card-shadow" }
const _hoisted_2 = { class: "md:mt-2 mt-1 md:text-4xl text-xl text-pink-700" }
const _hoisted_3 = { class: "md:mt-4 mt-1 text-gray-700 font-bold md:text-xl text-xs" }
const _hoisted_4 = { class: "md:mt-2 mt-1 text-gray-800 md:text-md text-xs font-medium" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.title), 1),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.description), 1)
  ]))
}